import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import downloadXlxs from 'utils/downloadXlxs';
import useVehicle from '../vehicle/useVehicle';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CalendarDay } from 'further-ui/utils';

type Props = {
  onSuccess?: () => void;
};

const useMutationOpts = (successMessage: string, onSuccess?: () => void) =>
  useHandleTrpcMutation()({
    successMessage,
    onSuccess,
  });

export default function useAccountsManagement({ onSuccess }: Props = {}) {
  const { selectedVehicleId } = useLayoutContext();
  const { vehicle } = useVehicle(selectedVehicleId);
  const deleteAccount = api.account.remove.useMutation(
    useMutationOpts('Account deleted successfully', onSuccess),
  );
  const createAccount = api.account.create.useMutation(
    useMutationOpts('Account created successfully', onSuccess),
  );
  const updateAccount = api.account.update.useMutation(
    useMutationOpts('Account updated successfully', onSuccess),
  );

  const exportAccounts = api.transactionType.exportList.useMutation({
    onSuccess: (data) => {
      downloadXlxs(
        data.file,
        `Transaction types - ${vehicle?.vehicleName} - ${new CalendarDay(
          new Date(),
        ).toLabel()}`,
      );
    },
  });

  return { createAccount, updateAccount, deleteAccount, exportAccounts };
}
